import React from "react";
import Section from '../Section/Section';
import SectionContent from '../SectionContent/SectionContent';
import Contact from '../../forms/Contact';

const ContactSection = () => (
  <Section id="contact">
    <SectionContent centered>
      <article>
        <h1>Contact</h1>
        <p>
          If you would like to contact us please fill out the form below or give us a call on <a href="tel:+447828883233">07828883233</a> we look forward to hearing from you!
        </p>
      </article>
      <Contact />
    </SectionContent>
  </Section>
)

export default ContactSection
